/**
 * OFC Game Factory Functions
 *
 * Convenience functions to create game states for each variant.
 * All use 'Cash-game' mode by default.
 */
import { OFCVariant } from './enums';
import { createInitialState } from './state';
import { GameState } from './types';

const createGame =
  (variant: OFCVariant) =>
  (playerCount: number): GameState =>
    createInitialState({ variant, playerCount, mode: 'Cash-game' });

export const StandardOFC = createGame(OFCVariant.OpenFaceChineseStandard);
export const PineappleOFC = createGame(OFCVariant.OpenFaceChinesePineapple);
export const PineappleFantasyOFC = createGame(OFCVariant.OpenFaceChinesePineappleFantasy);
export const DeuceToSevenOFC = createGame(OFCVariant.OpenFaceChineseDeuceToSeven);
export const DeuceToSevenPineappleOFC = createGame(OFCVariant.OpenFaceChinesePineappleDeuceToSeven);
export const JokerOFC = createGame(OFCVariant.OpenFaceChineseJoker);
export const JokerPineappleOFC = createGame(OFCVariant.OpenFaceChinesePineappleJoker);
